import * as React from "react";

const NextPage: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
            <path
                d="M1.02031 11.6601L6.68031 6.00009L1.02031 0.340088L0.320312 1.05009L5.27031 6.00009L0.320312 10.9501L1.02031 11.6601Z"
                fill="black"
            />
        </svg>
    );
};

export default React.memo(NextPage);
